import { useState, type FormEvent } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useSessao } from '../auth/SessaoContext';
import { ErroApi } from '../api/cliente';
import { Aviso, Botao, Campo } from '../componentes/ui';
import { CabecalhoAuth, MolduraAuth } from './MolduraAuth';
import css from './Auth.module.css';
import { rotaInicial } from '../auth/rotas';

export function Login() {
  const { entrar } = useSessao();
  const navegar = useNavigate();
  const local = useLocation();

  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function enviar(e: FormEvent) {
    e.preventDefault();
    setErro(null);
    setEnviando(true);
    try {
      const usuario = await entrar(email, senha);
      // Volta para onde o usuário tentou ir antes de ser barrado; sem isso,
      // cai na tela inicial do papel dele.
      const destino =
        (local.state as { de?: { pathname: string } } | null)?.de?.pathname ??
        rotaInicial(usuario);
      navegar(destino, { replace: true });
    } catch (err) {
      setErro(
        err instanceof ErroApi
          ? err.message
          : 'Não foi possível entrar. Verifique sua conexão.',
      );
    } finally {
      setEnviando(false);
    }
  }

  return (
    <MolduraAuth>
      <form onSubmit={enviar} noValidate className={css.pilha}>
        <CabecalhoAuth titulo="Bom te ver de novo">
          Entre para continuar suas buscas.
        </CabecalhoAuth>

        {erro && <Aviso>{erro}</Aviso>}

        <div className={css.campos}>
          <Campo
            rotulo="E-mail"
            type="email"
            name="email"
            autoComplete="email"
            required
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="voce@empresa.com.br"
          />
          <Campo
            rotulo="Senha"
            type="password"
            name="senha"
            autoComplete="current-password"
            required
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            placeholder="••••••••••"
          />
        </div>

        <Botao type="submit" larguraTotal grande carregando={enviando}>
          Entrar
        </Botao>

        <span className={css.alternativa}>
          Ainda não tem conta? <Link to="/criar-conta">Criar agora</Link>
        </span>
      </form>
    </MolduraAuth>
  );
}
